<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data style="margin-top:10px;"
        [title]="'MI Invoice Date Read Only Status'"
        [lotNumber]="_appGeneralState.currentLotNumber"
        [lotName]="_appGeneralState.currentLotName"
    ></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 700px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>

            <div style="margin-top:30px;"></div>
            <div class="ace-heading-text-secondary" style="font-size:21px;margin-left:10px;margin-bottom:10px;">
                @if(mIInvoiceDateReadOnlyStatus){
                    Lot {{_appGeneralState.currentLotNumber}}:  Current MI Invoice Date is set to the current date and cannot be entered by the user.
                }
                @else{
                    Lot {{_appGeneralState.currentLotNumber}}: Current MI Invoice Date can be entered by the user to their desired date.
                }
            </div>

            <div style="margin-top:20px;margin-left:10px;margin-bottom:10px;">
                <strong>Click Save Setting button to save current setting state for this lot.</strong>
            </div>
            <mat-button-toggle-group [(ngModel)]="readOnlySetting" aria-label="Font Style" style="margin-top:5px;">
                <mat-button-toggle value="readonly">Read Only - User CANNOT modify Invoice Date</mat-button-toggle>
                <mat-button-toggle value="notreadonly">User Can Enter desired Invoice Date</mat-button-toggle>
            </mat-button-toggle-group>
            <div style="margin-top:20px;">
                <button mat-flat-button (click)="onSaveMiReadOnlyState()">Save Setting</button>
            </div>
            


</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    
</mat-card-actions>

</mat-card>                                                                             

</div>


